import { DocumentClient } from '../clients/DocumentClient';

export const DocumentStore = {
  state: {
    documents: [],
    errors: [],
  },

  getters: {
    DOCUMENT_BY_ID: state => id => {
      return state.documents.find(document => document.id === id);
    },
  },
  mutations: {
    //synchronous
    SET_ERRORS: (state, errors) => {
      state.errors = errors;
    },
    SET_DOCUMENT: (state, newDoc) => {
      let foundExistingDoc = state.documents.find(
        document => document.id === this.newDoc.id
      );
      if (!foundExistingDoc) {
        state.documents.push(newDoc);
      }
    },
    SET_USER_DOCUMENTS: (state, documents) => {
      state.documents = documents;
    },
    SAVE_DOCUMENT: (state, document) => {
      const document_index = state.documents.findIndex(
        doc => doc.id === document.id
      );
      state.documents[document_index] = document;
    },
    UNSET_DOCUMENTS: state => {
      state.documents = [];
    },
    DELETE_ATTACHMENT: (state, payload) => {
      const document_index = state.documents.findIndex(
        doc => doc.id === payload.document.id
      );

      const attachment_index = state.documents[
        document_index
      ].attachments.findIndex(att => att.id === payload.attachment_id);
      state.documents[document_index].attachments.splice(attachment_index, 1);
    },
    ADD_ATTACHMENT: (state, payload) => {
      const document_index = state.documents.findIndex(
        doc => doc.id === payload.document.id
      );

      state.documents[document_index].attachments.push(payload.attachment);
    },
    ADD_POST_TO_DOCUMENT: (state, payload) => {
      const document_index = state.documents.findIndex(
        doc => doc.id === payload.document_id
      );

      state.documents[document_index].forum_post = payload;
    },
  },

  actions: {
    //asynchronous
    GET_DOCUMENT: async ({ commit }, payload) => {
      return DocumentClient.getDocument(payload)
        .then(function(res) {
          commit('SET_DOCUMENT', res.data.document);
        })
        .catch(function() {});
    },
    UNSET_DOCUMENTS: ({ commit }) => {
      commit('UNSET_DOCUMENTS');
    },
    CREATE_DOCUMENT: ({ commit, dispatch }, type) => {
      return DocumentClient.createDocument(type)
        .then(function(res) {
          //commit('SET_DOCUMENT', res.data.document);
          dispatch('GET_USER_DOCUMENTS');
        })
        .catch(function() {});
    },
    GET_USER_DOCUMENTS: async ({ commit }) => {
      return DocumentClient.getUserDocuments()
        .then(function(res) {
          commit('SET_USER_DOCUMENTS', res.data.documents);
        })
        .catch(function() {});
    },
    GET_PROJECT_DOCUMENT: async ({ commit }, payload) => {
      return DocumentClient.getUserProjectDocument(payload)
        .then(function(res) {
          commit('SET_DOCUMENT', res.data.document);
        })
        .catch(function() {});
    },
    SAVE_DOCUMENT: async ({ commit }, document) => {
      return DocumentClient.updateDocument(document)
        .then(function(res) {
          commit('SAVE_DOCUMENT', res.data.document);
        })
        .catch(function(err) {
          commit('SET_ERRORS', err.response.data.errors);
        });
    },
    DELETE_ATTACHMENT: async ({ commit }, payload) => {
      return DocumentClient.deleteAttachment(payload)
        .then(function(res) {
          commit('DELETE_ATTACHMENT', payload);
        })
        .catch(function() {});
    },
    ADD_ATTACHMENT: ({ commit }, payload) => {
      commit('ADD_ATTACHMENT', payload);
    },
    ADD_POST_TO_DOCUMENT: ({ commit }, payload) => {
      commit('ADD_POST_TO_DOCUMENT', payload);
    },
  },
};
